import { styled } from 'styled-components';
export const TabsGroupWrapper = styled.div `
  display: flex;
  position: relative;
  overflow-x: auto;
`;
export const TabWrapper = styled.div `
  ${({ theme }) => theme.typography.textMedium}
  ${({ theme }) => theme.typography.weightMedium}
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
  padding: 16px 12px;
  cursor: ${({ $active }) => ($active ? 'default' : 'pointer')};
  color: ${({ theme, $active }) => ($active ? theme.colors.black_1 : theme.colors.grey100_1)};

  &:hover {
    color: ${({ theme }) => theme.colors.black_1};
  }
`;
export const Title = styled.span `
  display: flex;
  white-space: nowrap;

  &:after {
    content: '';
    height: 3px;
    border-radius: 2px 2px 0 0;
    background-color: ${({ $active, theme }) => ($active ? theme.colors.main : 'transparent')};
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 0;
  }
`;
